import serviceCRUD from '../../../services/ServiceCRUDFLEXUC';

class TeamService extends serviceCRUD {
  constructor() {
    super('/api/user-team');
  }
}

export default new TeamService();
